export default {
  //导航栏
  barmessage: {
    Home: 'ທີ່ຕົ້ນ',
    data: 'ການກູ້ຄືນຂໍ້ມູນ',
    About: 'ກ່ຽວກັບພວກເຮົາ',
    productService: 'ບໍລິການສີນຄ້າ',
    cases: 'ສິ່ງຕົວຢ່າງ',
    news: 'ຂ່າວສານ',
    contactUs: 'ຕິດຕໍ່ພວກເຮົາ',
    login: 'ເຂົ້າລະບົບ',
    report: 'ສະຖິຕິຂໍ້ມູນ',
    LOGOtitle: 'ບໍ່ລິການ ຂໍ້ມູນ'
  },

  queryboardmessage: { //查询面板
    polygon: 'ຮູບຫຼາຍຫຼ່ຽມ',
    nominatim: 'ປ້ອນຊື່ສະຖານທີ່',
    producttype: 'ລະດັບຂອງຜະລິດຕະພັນ',
    cloud: 'ຈຳນວນໂມດ <',
    sensing: 'ວັນທີຖ່າຍທຳ',
    satellite: 'ເຊັນເຊີ້ດາວທຽມ',
    drawpolygon: 'ແຕ້ມຮູບຫຼາຍຫຼ່ຽມ',
    drawrectangle: 'ແຕ້ມຮູບສີ່ຫຼ່ຽມ',
    clear: 'ລ້າງສະພາບອາກາດ',
    query: 'ການກູ້ຄືນຂໍ້ມູນ',
    cart: 'ສະແດງ/ເຊື່ອມຕໍ່ຂໍ້ມູນ',
    togglebutton: 'ສະລັບແຜງແບບສອບຖາມ',
    uploadfailed: 'ຮູບແບບຂໍ້ມູນທີ່ບໍ່ຮອງຮັບ',
    uploadsuccessed: 'ອັບໂຫຼດຂໍ້ມູນເອກະສານສົມບູນສຳເລັດ',
    uploadbutton: 'ອັບໂຫຼດເອກະສານ',
    uploadtitle: 'ອັບໂຫຼດເອກະສານສົມບູນ',
    upoladtip: 'ສະໜັບສະໜູນໄອຄອນ .shp (ໄຟລ໌ .zip ມີ .dbf .shp .prj ຊື່ໄຟລ໌ຈຳນວນສາມາດໃຊ້ທີ່ພາສາອັງກິດ)',
  },

  querymapmessage: { //查询底图上的文字
    lonlat: 'ເສັ້ນແຫວ່ງ ແລະ ເສັ້ນຂະໜານ',
    fullscreen: 'ສະລັບໜ້າຈໍທັງໝົດ',
    owslayername: 'ແຜນຜັງ OSM',
    satellitelayername: 'ແຜນຜັງຖານພາບຮັບຮູ້ໄລຍະໄກ',
  },

  resultlistmessage: { //查询结果面板,部分与购物车面板共用
    satellite: 'ດາວທຽມ',
    sensingdate: 'ວັນທີຖ່າຍທຳ',
    online: 'ອອນລາຍ',
    offline: 'ປິດການໃຊ້ງານ',
    display: 'ສະແດງ {startindex} ການ {endindex} ຂອງ {count} ສີນຄ້າ',
    cartdisplay: 'ກະຕ່າງທ່ານມີ { itemcount } ສີນຄ້າ.',
    nofound: 'ບໍ່ພົບເຫັນສີນຄ້າ',
    viewdata: 'ເບິ່ງລາຍລະອຽດຂໍ້ມູນ',
    zoomtodata: 'ຄົ້ນຫາຂໍ້ມູນ',
    downloaddata: 'ດາວໂຫຼດຂໍ້ມູນ',
    tocart: 'ເພີ່ມຂໍ້ມູນໃນກະຕ່າສີນຄ້າ',
    removecart: 'ລົບອອກຈາກກະຕ່າສີນຄ້າ',
    offlinewaring: 'ຜະລິດຕະພັນອອບລາຍ',
  },
  userprofilemessage: {

    edit: 'ແກ້ໄຂຂໍ້ມູນຜູ້ໃຊ້',
    logout: 'ອອກຈາກລະບົບ',
    function: 'ມີຄຸນນະສົມບັດ',
    download: 'ດາວໂຫຼດຂໍ້ມູນ',
    search: 'ຄົ້ນຫາຂໍ້ມູນ',
  },
  fpmessage: { // 忘记密码面板

    title: 'ລືມລະຫັດຜ່ານ',
    mess: 'ກະລຸນາຕື່ມຂໍ້ມູນເພື່ອທີ່ຈະໄດ້ຕັ້ງລະຫັດຜ່ານໃຫມ່ຂອງທ່ານ.',
    username: 'ຊື່ຜູ້ໃຊ້',
    usernameempty: 'ຍັງບໍ່ມີຊື່ຜູ້ໃຊ້',
    emailvalid: 'ຮູບແບບອີເມວບໍ່ຖືກຕ້ອງ',
    email: 'ອີເມວ',
    send: 'ສົ່ງ',
    errtitle: 'ການຮັບລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ',
    errmess: 'ບໍ່ພົບຜູ້ໃຊ້ທີ່ມີຊື່ຜູ້ໃຊ້ນີ້/ທີ່ມີອີເມວນີ້',
    succtitle: 'ການຮັບລະຫັດຜ່ານສຳເລັດ',
    succmess: 'ມີອີເມວສົ່ງເຖີງທ່ານແລ້ວພ້ອມຄຳແນະນຳວີທີການຕັ້ງລະຫັດຜ່ານໃໝ່',
  },
  rpmessage: { //重置密码面板
    title: 'ປ່ຽນລະຫັດຜ່ານ',
    mess: 'ກະລຸນາຕື່ມຂໍ້ມູນເພື່ອປ່ຽນລະຫັດຜ່ານຂອງທ່ານ.',
    passwdrule: 'ລະຫັດຜ່ານຕິດຕັ້ງອະນຸມັດຕົວອັກສອນຕົວເລກຊັ່ນທີ່ນີ້! @ # $ % ^ & * ) ( + = . _ -. ຈຳນວນຕົວອັກສອນໜ້ອຍສຸດ8ຕົວ',
    passwd: 'ລະຫັດຜ່ານ',
    emptypasswd: 'ລະຫັດຜ່ານວ່າງ',
    passwdvalid: 'ລະຫັດຜ່ານຈຳນວນຕົວອັກສອນໜ້ອຍສຸດ8ຕົວ',
    confirmpasswdvalid: 'ລະຫັດຜ່ານບໍ່ກົງກັບຄ່າທີ່ປ້ອນ',
    confirmpasswd: 'ຢືນຢັນລະຫັດຜ່ານ',
    send: 'ສົ່ງ',
    mbtitle1: 'ປ່ຽນລະຫັດຜ່ານ',
    mbresult1: 'ທ່ານໄດ້ປ່ຽນລະຫັດຜ່ານສຳເລັດແລ້ວ',
    mbresult2: 'ການປ່ຽນລະຫັດຜ່ານມີຂໍ້ຜິດພາດ',
    mbtitle2: 'ປ່ຽນລະຫັດຜ່ານລົ້ມເຫດ',

  },
  registmessage: { //注册面板
    title: 'ລົງທະບຽນສະມາຊິກໃຫມ່',
    header1: 'ສະມາຊິກທີ່ລົງທະບຽນການໃຊ້ບໍລິການໂດຍຟຣີສະແດງຂໍ້ມູນໄປຈາກເວັບໄຊທ໌ຟ້າຍ',
    notice1: 'ຫຼັງຈາກກອກຟອມຂໍ້ມູນລົງທະບຽນສຳເລັດແລ້ວ ທ່ານຈະໄດ້ຮັບລີ້ງຈາກອີເມວເພື່ອຍືນຢັນທີ່ຢູ່ຂອງທ່ານ ຫຼັວຈາກນັ້ນທ່ານສາມາດເລີ່ມດາວໂຫຼດຂໍ້ມູນໄດ້ ຊື່ຜູ້ໃຊ້ສາມາດຂຽນໄດ້ສະເພາະ“.”、“-”“_”。ຈຳນວນຕົວອັກສອນໜ້ອຍສຸດ8ຕົວ“!”、“@”、“#”、“$”、“%”、“^”、“&”、“*”、“)”、“(”、“+”  "=" "." "_" "-"',
    firstname: 'ຊື່ ',
    lastname: 'ນາມສະກຸນ',
    username: 'ຊື່ຜູ້ໃຊ້',
    passwd: 'ລະຫັດຜ່ານ',
    confirmpasswd: 'ຢືນຢັນລະຫັດຜ່ານ',
    company: 'ຊື່ບໍລິສັດ/ສຳນັກງານ/ອົງກອນ',
    email: 'ທີ່ຢູ່ອີເມວ',
    confirmemail: 'ຢືນຢັນທີ່ຢູ່ອີເມວ',
    emailcheck: 'ຮູບແບບທີ່ຢູ່ອີເມວບໍ່ຖືກຕ້ອງ',
    emailmatch: 'ຂໍ້ມູນບໍ່ກົງກັບອີເມວທີ່ຢູ່',
    selectdomain: 'ເລືອກເຂດຂໍ້ມູນ',
    selecteducation:"ການຮຽນຮູ້",
    selectoccupation:"ອາຊີບ",
    selectusage: 'ເລືອກການນໍາໃຊ້',
    selectcountry: 'ເລືອກປະເທດ',
    register: 'ລົງທະບຽນ',
    shouquan: 'ການລົງທະບຽນໃນເວັບໄຊນີ້ແລະເງື່ອນໄຂໄດ້ຖືກຍອມຮັບແລ້ວຈາກGF',
  },
  editprofilemessage: { //编辑用户信息面板
    title: 'User {username} profile',
    firstname: 'ຊື່',
    firstnameempty: 'ຍັງບໍ່ໄດ້ຂຽນຊື່',
    lastnameempty: 'ຍັງບໍ່ໄດ້ຂຽນສະກຸນ',
    lastname: 'ນາມສະກຸນ',
    username: 'ຊື່ຜູ້ໃຊ້',
    passwd: 'ລະຫັດຜ່ານ',
    confirmpasswd: 'ຢືນຢັນລະຫັດຜ່ານ',
    company: 'ຊື່ບໍລິສັດ/ສຳນັກງານ/ອົງກອນ',
    email: 'ອີເມວ',
    confirmemail: 'ຢືນຢັນອີເມວ',
    emailcheck: 'ຮູບແບບທີ່ຢູ່ອີເມວບໍ່ຖືກຕ້ອງ',
    emailmatch: 'ຂໍ້ມູນບໍ່ກົງກັບອີເມວທີ່ຢູ່',
    selectdomain: 'ເລືອກເຂດຂໍ້ມູນ',
    selectusage: 'ເລືອກການນໍາໃຊ້',
    selectcountry: 'ເລືອກປະເທດ',
    passwordalerm1: 'ກະລຸນາປ້ອນລະຫັດຜ່ານ',
    passwordalerm2: 'ຈຳນວນຕົວອັກສອນໜ້ອຍສຸດ8ຕົວ',
    oldpasswd: 'ປ້ອນລະຫັດຜ່ານເກົ່າ',
    savemodification: 'ບັນທືກການປ່ຽນແປງ',
    selecteducation:"ການຮຽນຮູ້",
    selectoccupation:"ອາຊີບ",
    passwdrule1: 'ລະຫັດຜ່ານຕິດຕັ້ງອະນຸມັດຕົວອັກສອນຕົວເລກຊັ່ນທີ່ນີ້!! @ # $ % ^ & * ) ( + = . _ -. ',
    passwdrule2: 'ຄວາມສູງສຸດຂອງລະຫັດຜ່ານຕໍ່ໄປເທື່ອ 8 ຕົວອັກສອນ',
    changepasswd: 'ປ່ຽນລະຫັດຜ່ານ',
  },
  loginmessage: { //登陆面板
    title: 'ກະລຸນາເຂົ້າສູ່ລະບົບເພື່ອເຂົ້າຊົມບໍລິການຂອງພວກເຮົາ…',
    username: 'ຊື່ຜູ້ໃຊ້',
    passwd: 'ລະຫັດຜ່ານ',
    loginbutton: 'ເຂົ້າສູ່ລະບົບ',
    signup: 'ລົງທະບຽນ',
    fpasswd: 'ລືມລະຫັດຜ່ານ?',
    passwderr: 'ກະລຸນາປ້ອນລະຫັດຜ່ານ',
    loginsuccess: 'ຄວາມສູງສຸດຂອງລະຫັດຜ່ານຕໍ່ໄປເທື່ອ 8 ຕົວອັກສອນ',
    logoutsuccess: 'ຊື່ຜູ້ໃຊ້ແລະລະຫັດຜ່ານທີ່ທ່ານໃສ່ບໍ່ກົງກັບຫຼືຜູ້ສະຫມັກໃຊ້',
  },
  servicemessage: { //服务状态
    mess: 'ເຂົ້າສູ່ລະບົບສຳເລັດ',
  },

  downloadmessage: { //数据下载面板信息
    title: 'ອອກຈາກລະບົບສຳເລັດ',
    downloadmess: 'ບໍລິການເວັບໄຊທ໌ປິດການສະແດງບໍລິການ',
    closemess: 'ລາຍລະອຽດຂໍ້ມູນ',
    propertyname: 'ຊື່ຄຸ້ມຄອງ:',
    propertyvalue: 'ຄຸ້ມຄອງ:',
    satellite: "ປະເພດ:",
    sensor: "ວິທະຍາສາ:",
    dataid: "ລະຫັດຂໍ້ມູນ:",
    image_start_time: "ວັນເລີ່ມການວິທະຍາສາ:",
    data_size: "ຂະໜາດ(GB):",
    orbit_num: "ຈຳນວນການເດີກ",
    st_astext: "ຄ່າປະກາດຄວາມ",
    productlevel: "ລະດັບຜະລິດ",
    cloud_cover: "ເຄື່ອງມືການສົ່ງຄ່າອາກາດ (%)",
    offline_flag: "ອອຟທັບ",
  },
  vdusermessage: { //激活用户
    title: 'ດາວໂຫຼດຂໍ້ມູນຜະລິດຕະພັນ',
    success: 'ປິດ',
    failed: 'ການເປີດບັນຊີສຳເລັດ',
  },
  gf1message: {

  },
  gf2message: {
    p1mess: 'ການເປີດບັນຊີລົ້ມເຫຼວ',
  },
  gf6message: {},
  reportmessage: {
    title: 'ສະບັບການແບ່ງປັນຂໍ້ມູນທັງຫມົດຈາກເບື້ອງກຳໄລຈໍານວນຈາກການເຮັດວຽກ',
    RUsers: 'ຜູ້ລົງທະບຽນ',
    download: 'ຈຳນວນຜູ້ສະຫມັກໃຊ້',
    Productsnum: 'ຈຳນວນຜະລິດຕະພັນ',
    Availability: 'ສາມາດນຳໃຊ້ໄດ້ໃນໄລຍະໜື່ງເດືອນ',
  }
};